import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";

const state = {
    bonuses: [],
    totalItems:0,

};

const getters = {
    index: state => bonusId => state.bonuses.findIndex(i => i.bonusId === bonusId)
};

const mutations = {
    setBonuses: (state, r) => (state.bonuses = r),
    setTotalItems: (state, r) => (state.totalItems = r),
};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.bonuses.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setBonuses", response.data.bonuses);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
 
// ------------------------------------ print ----------------
async getEmploymentBonus(_, id) {
    try {
     
        startLoading()
        const response = await dataService.bonuses.getEmploymentBonus(id);
        stopLoading()

        if (!response.data.statusCode) {
            showAlert(serverErrorMessage);
            return;
        }

        return Promise.resolve(response.data);

    } catch (error) {
        stopLoading()
        catchHandler(error);
    }},
async getCurrentBonus(_, id) {
    try {
     
        startLoading()
        const response = await dataService.bonuses.getCurrentBonus(id);
        stopLoading()

        if (!response.data.statusCode) {
            showAlert(serverErrorMessage);
            return;
        }

        return Promise.resolve(response.data);

    } catch (error) {
        stopLoading()
        catchHandler(error);
    }
}
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
